import ActionTypes from './order-details.types';

const initialState = {
  response: {},
  isLoading: false,
  hasError: false,
  errorMessage: '',
};

const orderDetailsReducer = (state: object = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case ActionTypes.GET_ORDER_DETAILS_START:
      return {
        ...state,
        response: {},
        isLoading: true,
        hasError: false,
        errorMessage: '',
      };

    case ActionTypes.GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        response: action.payload,
        isLoading: false,
        hasError: false,
        errorMessage: '',
      };

    case ActionTypes.GET_ORDER_DETAILS_FAILURE:
      return {
        ...state,
        response: {},
        isLoading: false,
        hasError: true,
        errorMessage: action.payload,
      };

    default:
      return state;
  }
};

export default orderDetailsReducer;
